import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuth, usePlan, isPaidPlan } from "../lib/auth";

interface SidebarProps {
  onNavigate?: () => void;
}

const ITEMS = [
  { to: "/", key: "dashboard", end: false, paidOnly: false },
  { to: "/compare", key: "compare", end: false, paidOnly: false },
  { to: "/brand-kit", key: "brandKit", end: false, paidOnly: false },
  { to: "/integrations", key: "integrations", end: false, paidOnly: false },
  { to: "/settings", key: "settings", end: false, paidOnly: false },
  { to: "/support", key: "support", end: false, paidOnly: false },
] as const;

export default function Sidebar({ onNavigate }: SidebarProps) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const plan = usePlan();
  const items = ITEMS.filter((item) => !item.paidOnly || isPaidPlan(plan));
  const linkClass = (active: boolean) =>
    `block px-3 py-2 rounded-md text-sm font-medium ${
      active ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-200"
    }`;

  return (
    <nav className="h-full bg-white border-r border-slate-200 px-3 py-4 flex flex-col">
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              onClick={onNavigate}
              className={({ isActive }) => linkClass(isActive)}
            >
              {t(`sidebar.${item.key}`)}
            </NavLink>
          </li>
        ))}
      </ul>
      {user?.role === "admin" && (
        <ul className="mt-auto pt-2 border-t border-slate-200">
          <li>
            <NavLink
              to="/admin"
              onClick={onNavigate}
              className={({ isActive }) => linkClass(isActive)}
            >
              {t("sidebar.admin")}
            </NavLink>
          </li>
        </ul>
      )}
    </nav>
  );
}
